// NPM
import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';

// I18N
import PurchaseFormattedMessages from '../../messages/billing/PurchaseFormattedMessages';

// ROUTES
import { BillingRoutes } from '../../routes/BillingRoutes';

// NETWORK
import usePurchaseRequest from '../../requests/PurchaseRequest';

// COMPONENTS
import Layout from '../../components/layouts/Layout';
import ErrorList from '../../components/common/ErrorList';
import StagedModal from '../../components/common/StagedModal';
import PurchaseTable from '../../components/billing/purchase/PurchaseTable';
import Loader from '../../components/common/Loader';

const PurchaseMessages = ({
  customer,
  user,
  errorHandler,
  accessLevel,
  accessType,
  navigate,
}) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [list, setList] = useState([]);
  const [showStaged, setShowStaged] = useState(false);
  const [stage, setStage] = useState(0);
  const [selected, setSelected] = useState(null);
  const [stripeRate, setStripeRate] = useState(null);
  const [modalError, setModalError] = useState('');
  const [modalBillId, setModalBillId] = useState(null);
  const { getTariffLines, purchaseMessages } = usePurchaseRequest();

  const getTariffs = async () => {
    setLoading(true);
    const results = await getTariffLines();
    const tariffs = results.tariffLines;
    const stripeRate = results.stripeRate * 100;
    console.log('tariffs: ', tariffs);
    setData(results.results);
    setList(tariffs);
    setStripeRate(stripeRate);
    setLoading(false);
    return tariffs;
  };

  useEffect(() => {
    if (customer) {
      getTariffs();
    }
  }, [customer]);

  const handleShowStaged = (element) => {
    setShowStaged(true);
    setSelected(element);
  };

  const purchase = async () => {
    if (!selected) {
      setShowStaged(false);
      setStage(0);
      return;
    }
    const tariffPlanId = selected.tariff_plan_id;
    const tariffLineId = selected.tariff_line_id;
    const customerId = customer.customer_id;
    const customerUserId = user.customer_user_id;
    setStage(1);
    const results = await purchaseMessages(
      tariffPlanId,
      tariffLineId,
      customerId,
      customerUserId,
      errorHandler
    );

    if (results && !results.expectedError && !results.error) {
      setStage(2);
    } else {
      let errorMsg = 'Could not retrieve results.';
      let billId;
      if (results) {
        console.log('purchase results:', results);
        errorMsg = results.expectedError || results.error || errorMsg;
        if (results.billId) {
          billId = results.billId;
          errorMsg += '. Do you want to go to the created bill?';
        } else if (results.conflictBillId) {
          billId = results.conflictBillId;
          errorMsg += '. Do you want to go to the conflicting bill?';
        }
      }
      setStage(3);
      setModalError(errorMsg);
      setModalBillId(billId);
    }

    console.log('purchase results: ', results);
  };

  const generateBody = () => {
    return <PurchaseTable list={list} purchase={handleShowStaged} />;
  };

  const generateErrorList = () => {
    return <ErrorList hasError={false} errors={[]} />;
  };

  return (
    <Layout
      routes={BillingRoutes}
      title={PurchaseFormattedMessages.purchaseMessages}
      accessLevel={accessLevel}
      accessType={accessType}
      customerType={customer?.customer_type}
    >
      <Typography gutterBottom>
        * All purchases will incur an additional {stripeRate}% processing fee.
      </Typography>

      {loading ? (
        <Loader />
      ) : (
        <>
          {generateBody()}
          <StagedModal
            showStaged={showStaged}
            removeStaged={() => setShowStaged(false)}
            removeStagedSlow={() =>
              setStage(0) && setModalError('') && setModalBillId(null)
            }
            performAction={purchase}
            performErrorAction={
              modalBillId && customer
                ? () =>
                    navigate(
                      `/billing/invoiceshow/${customer.customer_id}/${modalBillId}`
                    )
                : undefined
            }
            stage={stage}
            stageTitle="Purchase Message Confirmation"
            stageConfirmation="Are you sure you would like to purchase these messages?"
            stagePending="Message purchase pending..."
            stageSuccess="Message purchase successful!"
            stageFailure={modalError || 'Message purchase failed!'}
          />
        </>
      )}
    </Layout>
  );
};

export default PurchaseMessages;
